module.exports = {
	validGamUprFloorValues: [
		'0.06',
		'0.08',
		'0.10',
		'0.12',
		'0.14',
		'0.15',
		'0.17',
		'0.20',
		'0.22',
		'0.23',
		'0.25',
		'0.28',
		'0.30',
		'0.32',
		'0.35',
		'0.37',
		'0.40',
		'0.43',
		'0.45',
		'0.46',
		'0.48',
		'0.50',
		'0.52',
		'0.55',
		'0.58',
		'0.60',
		'0.62',
		'0.65',
		'0.68',
		'0.70',
		'0.75',
		'0.78',
		'0.80',
		'0.85',
		'0.90',
		'0.95',
		'1.00',
		'1.10',
		'1.18',
		'1.25',
		'1.30',
		'1.35',
		'1.40',
		'1.45',
		'1.50',
		'1.55',
		'1.60',
		'1.65',
		'1.70',
		'1.75',
		'2.00',
		'2.25',
		'2.50',
		'2.75',
		'3.00',
		'3.25',
		'3.50',
		'3.75',
		'4.00',
		'4.25',
		'4.50',
		'4.75',
		'5.00',
		'5.25',
		'5.50',
		'5.75',
		'6.00',
		'6.25',
		'6.50',
		'6.75',
		'7.00',
		'7.25',
		'7.50',
		'7.75',
		'8.00',
		'8.25',
		'8.50',
		'8.75',
		'9.00',
		'9.25',
		'9.50',
		'9.75',
		'10.00',
		'10.25',
		'10.50',
		'10.75',
		'11.00',
		'11.25',
		'11.50',
		'11.75',
		'12.00',
		'12.25',
		'12.50',
		'12.75',
		'13.00',
		'13.25',
		'13.50',
		'13.75',
		'14.00',
		'14.25',
		'14.50',
		'14.75',
		'15.00',
		'15.50',
		'16.00',
		'16.50',
		'17.00',
		'17.50',
		'18.00',
		'18.50',
		'19.00',
		'19.50',
		'20.00',
		'20.75',
		'21.50',
		'22.25',
		'23.00',
		'23.75',
		'24.50',
		'25.25',
		'26.00',
		'26.75',
		'27.50',
		'28.25',
		'29.00',
		'29.75',
		'32.00',
		'34.25',
		'35.00'
	],
	globalFloorsMapping: {
		"0.01": "hvbxgd",
		"0.02": "qtwhsb",
		"0.04": "clapsd",
		"0.05": "gbjiuq",
		"0.06": "apzpzsx",
		"0.07": "zmxkud",
		"0.08": "apzpztw",
		"0.09": "vvkogz",
		"0.10": "hhausd",
		"0.12": "quuaas",
		"0.13": "gqyuug",
		"0.14": "vupwlx",
		"0.15": "ajsidi",
		"0.16": "bmfjww",
		"0.17": "oqnhqt",
		"0.18": "ulynkb",
		"0.19": "eafbvs",
		"0.20": "ajaasf",
		"0.22": "medpku",
		"0.23": "asvjyl",
		"0.25": "raegiv",
		"0.26": "rcunco",
		"0.28": "phmjxy",
		"0.30": "aaqdnf",
		"0.31": "tqgysc",
		"0.32": "hpywmq",
		"0.33": "uyvwym",
		"0.35": "hhauqa",
		"0.37": "ahaash",
		"0.38": "ohanzn",
		"0.40": "apzpfz",
		"0.43": "ffebpa",
		"0.44": "jyjxrk",
		"0.45": "asdkfh",
		"0.46": "syxuoc",
		"0.48": "dsmbca",
		"0.50": "acnsha",
		"0.52": "liwnya",
		"0.55": "yxbvhs",
		"0.58": "szzcce",
		"0.60": "uuensa",
		"0.62": "aasnvh",
		"0.65": "llapsi",
		"0.68": "adlhwo",
		"0.70": "aajskd",
		"0.75": "cryiou",
		"0.78": "ubwgih",
		"0.80": "yyahsn",
		"0.85": "lugmus",
		"0.90": "ffczwz",
		"0.95": "pvgukf",
		"1.00": "unmvax",
		"1.10": "vjscoe",
		"1.18": "fmspvp",
		"1.25": "wdvsfe",
		"1.30": "teyocf",
		"1.35": "pvhysu",
		"1.40": "vtqmse",
		"1.45": "zohqvd",
		"1.50": "tnlubl",
		"1.55": "sqdplx",
		"1.60": "eglslv",
		"1.65": "ovxfio",
		"1.70": "xngmsf",
		"1.75": "hpnigd",
		"2.00": "wypjsl",
		"2.25": "xlkyde",
		"2.50": "vbzacw",
		"2.75": "mhtrcf",
		"3.00": "speczp",
		"3.25": "hykmbo",
		"3.50": "fzhblj",
		"3.75": "nvhjiy",
		"4.00": "mzaqqc",
		"4.25": "jhajsd",
		"4.50": "jqsizf",
		"4.75": "hqiakd",
		"5.00": "uwgxnm",
		"5.25": "hhajsd",
		"5.50": "cumbfo",
		"5.75": "akznch",
		"6.00": "ryetde",
		"6.25": "ydhnsz",
		"6.50": "nucvfk",
		"6.75": "jamxnj",
		"7.00": "polnip",
		"7.25": "yahsnh",
		"7.50": "hjtlkt",
		"7.75": "jajshb",
		"8.00": "tgmxfb",
		"8.25": "janshf",
		"8.50": "tfbkrf",
		"8.75": "hjaksk",
		"9.00": "dcweat",
		"9.25": "ajnhvl",
		"9.50": "sutfbn",
		"9.75": "amvjsk",
		"10.00": "wfqbue",
		"10.25": "halnvz",
		"10.50": "matxsy",
		"10.75": "amvxbz",
		"11.00": "wvyqaq",
		"11.25": "mchhks",
		"11.50": "myezfo",
		"11.75": "mvnzhs",
		"12.00": "ajljba",
		"12.25": "mmvjai",
		"12.50": "fraagu",
		"12.75": "mamzjv",
		"13.00": "yepval",
		"13.25": "majgoq",
		"13.50": "iaxxjv",
		"13.75": "kkalss",
		"14.00": "wgepmr",
		"14.25": "majfhs",
		"14.50": "pmqitr",
		"14.75": "quahfs",
		"15.00": "nvpifr",
		"15.50": "wbixbo",
		"16.00": "cqkxsc",
		"16.50": "ywkjyi",
		"17.00": "mfapfr",
		"17.50": "cfsfqz",
		"18.00": "khwpbq",
		"18.50": "xpvdgi",
		"19.00": "fzdtdo",
		"19.50": "pqftfo",
		"20.00": "vxtmmg",
		"20.75": "ajdfas",
		"21.50": "auwhha",
		"22.25": "ajuuwn",
		"23.00": "yyqtgs",
		"23.75": "jjauee",
		"24.50": "jauwqa",
		"25.25": "uaxhdn",
		"26.00": "nchhal",
		"26.75": "asdfjn",
		"27.50": "bhduds",
		"28.25": "vnshfu",
		"29.00": "vbgdtr",
		"29.75": "utyskd",
		"32.00": "qudpfv",
		"34.25": "hhffss",
		"35.00": "jaisdp"
	},
	GAM_UPR_PLATFORMS: ['DESKTOP', 'MOBILE', 'TABLET', 'DEFAULT']
};
